import { manufacturingFetch } from "@/lib/manufacturingClient";

export function returnManufacturingMaterial(payload: {
  material_id: string;
  quantity: number;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; entry_id: string; on_hand_qty: number }>(
    "/api/mfg/materials/return",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function scrapManufacturingMaterial(payload: {
  material_id: string;
  quantity: number;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; entry_id: string; on_hand_qty: number }>(
    "/api/mfg/materials/scrap",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function revalueManufacturingMaterialOnHand(payload: {
  material_id: string;
  unit_cost: number;
  notes?: string;
}) {
  return manufacturingFetch<{
    ok: true;
    entry_id: string | null;
    unit_cost: number;
    unchanged: boolean;
  }>("/api/mfg/materials/revalue-on-hand", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function adjustManufacturingMaterialOnHand(payload: {
  material_id: string;
  on_hand_qty: number;
  notes?: string;
}) {
  return manufacturingFetch<{
    ok: true;
    entry_id: string | null;
    on_hand_qty: number;
  }>("/api/mfg/materials/adjust-on-hand", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export type InterPlantTransferSummary = {
  id: string;
  from_plant_id: string;
  to_plant_id: string;
  material_id: string;
  quantity: number;
  unit_cost_usd: number;
  status: string;
  notes: string;
  transferred_at: string | null;
  created_at: string;
};

export function createManufacturingInterPlantTransfer(payload: {
  from_plant_id: string;
  to_plant_id: string;
  material_id: string;
  quantity: number;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; transfer: InterPlantTransferSummary }>(
    "/api/mfg/inter-plant-transfers/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function completeManufacturingInterPlantTransfer(transferId: string) {
  return manufacturingFetch<{ ok: true; transfer: InterPlantTransferSummary }>(
    "/api/mfg/inter-plant-transfers/complete",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transfer_id: transferId }),
    },
  );
}

export function cancelManufacturingInterPlantTransfer(transferId: string) {
  return manufacturingFetch<{ ok: true; transfer: InterPlantTransferSummary }>(
    "/api/mfg/inter-plant-transfers/cancel",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transfer_id: transferId }),
    },
  );
}

export { reorderThresholdFromMetadata } from "./reorderThreshold";
